import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SectionTrail from '../SectionTrail/SectionTrail';
import { planSelector } from '../../scenes/Dashboard/scenes/Plan/PlanSelectors';
import { dashboardContentVariantSelector } from '../../scenes/Organisation/OrganisationSelectors';
import { getPlanSections } from '../../scenes/Dashboard/scenes/Plan/planSections';

function getSectionStatus(section, sectionIndex, currentIndex, progress) {
  if (sectionIndex === currentIndex) return 'active';

  if (section.progressKey) {
    if (!progress) return 'incomplete';
    const val = Number(progress[section.progressKey]);
    if (Number.isFinite(val)) {
      const pct = val <= 1 ? val : val / 100;
      if (pct >= 0.999) return 'complete';
      if (pct > 0)      return 'in-progress';
    }
    return 'incomplete';
  }

  return sectionIndex < currentIndex ? 'complete' : 'incomplete';
}

function PlanSectionTrail({ location, progress, loading, dashboardContentVariant }) {
  const planSections = getPlanSections(dashboardContentVariant);
  const currentIndex = planSections.findIndex(s => location.pathname.startsWith(s.route));
  if (currentIndex === -1) return null;

  const sections = planSections.map((section, i) => ({
    ...section,
    route: section.link || section.route,
    status: getSectionStatus(section, i, currentIndex, progress),
  }));

  return <SectionTrail sections={sections} ariaLabel="Plan section progress" loading={loading} />;
}

const mapStateToProps = state => {
  const plan = planSelector(state);
  return {
    progress: plan ? plan.progress : null,
    loading: Boolean(state.planReducer?.loadingPlans),
    dashboardContentVariant: dashboardContentVariantSelector(state),
  };
};

export default withRouter(connect(mapStateToProps)(PlanSectionTrail));
